import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Slucuje CSS tridy s inteligentnim resenim Tailwind konfliktu.
 * Pouziva clsx pro podminene tridy + tailwind-merge pro deduplikaci.
 *
 * @example
 * cn('px-4 py-2', condition && 'bg-red-500', className)
 * // className="px-8" spravne prepise px-4
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
